import { useEffect } from 'react';
import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);
CustomEase.create('swipe', 'M0,0 C1,0 0,1 1,1');
CustomEase.create('reveal', 'M0,0 C1,0 0,1 1,1');

export default function Preloader({ onComplete }) {
  useEffect(() => {
    let cancelled = false;
    const tl = gsap.timeline({
      onComplete: () => {
        if (!cancelled) onComplete?.();
      },
    });

    tl.set('.preloader-logo', {
      opacity: 0,
      scale: 0.8,
    });

    tl.to('.preloader-logo', {
      opacity: 1,
      scale: 1,
      duration: 0.8,
      ease: 'power3.out',
    }, 0.1);

    tl.to('.preloader', {
      backgroundColor: '#ffffff',
      duration: 0.4,
      ease: 'power2.inOut',
    }, 0.6);

    tl.to('.preloader-logo', {
      opacity: 0,
      scale: 1.1,
      duration: 0.4,
      ease: 'power2.in',
    }, 0.9);

    tl.to('.preloader', {
      scaleY: 0,
      transformOrigin: 'top center',
      duration: 0.85,
      ease: 'swipe',
    }, 1.3);

    const handleClick = () => {
      tl.kill();
      gsap.set('.preloader', { display: 'none' });
      document.body.classList.add('preloader-finished');
      document.body.style.overflow = '';
      onComplete?.();
    };

    const preloader = document.querySelector('.preloader');
    if (preloader) preloader.addEventListener('click', handleClick, { once: true });

    return () => {
      cancelled = true;
      if (preloader) preloader.removeEventListener('click', handleClick);
    };
  }, [onComplete]);

  return (
    <div className="preloader" aria-hidden="true">
      <img className="preloader-logo" src="/assets/img/logo-preloader.svg" alt="" />
    </div>
  );
}
